import { DatapointConfig } from 'owa-analytics-actions';
import * as trace from 'owa-trace';

export default function extractConfig(
    actionType: string,
    config: any,
    middlewareParams: any
): DatapointConfig | undefined {
    if (!config) {
        return undefined;
    }
    return {
        name: extractPropertySafely(actionType, config, 'name', middlewareParams),
        customData: extractPropertySafely(actionType, config, 'customData', middlewareParams),
        options: extractPropertySafely(actionType, config, 'options', middlewareParams),
        cosmosOnlyData: extractPropertySafely(
            actionType,
            config,
            'cosmosOnlyData',
            middlewareParams
        ),
        actionSource: extractPropertySafely(actionType, config, 'actionSource', middlewareParams),
    };
}

function extractPropertySafely(
    actionType: string,
    config: any,
    property: string,
    middlewareParams: any
): any {
    if (config[property]) {
        try {
            return typeof config[property] === 'function'
                ? config[property].apply(null, middlewareParams)
                : config[property];
        } catch (e) {
            trace.errorThatWillCauseAlert(`${actionType} failed to extract ${property}`, e);
        }
    }
    return undefined;
}
